<script setup lang="ts">
import SelectOrganization from "@/components/RoleAssignment/SelectOrganization.vue"
import organizationType from "@/types/requests/organizationType"
import RoleName from "@/components/RoleAssignment/RoleName.vue"
import getRole from "@/types/responses/getRole"
import { ref, Ref, computed } from "vue"

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: {
    organization: organizationType | null,
    role: getRole | null
  }
  organizations: organizationType[]
  roles: getRole[]
  windowInnerWidth: number
  errorMessages: {
    organization: string[],
    roleType: string[],
    userSearchOrganization: string[]
  }
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const selectableRoles = computed(() => {
  if (!props.modelValue.organization) return []
  return props.roles.filter((role: getRole) => {
    return role.organization_id == props.modelValue.organization?.id &&
      role.organization_type == props.modelValue.organization?.type
  })
})
</script>
<template>
  <div class="mt-6">
    <SelectOrganization
      v-model="modelValue.organization"
      :organizations="props.organizations"
      :windowInnerWidth="windowInnerWidth"
      :errorMessages="props.errorMessages.organization"
    />
    <RoleName
      v-model="modelValue.role"
      :roles="selectableRoles"
      :windowInnerWidth="windowInnerWidth"
      :errorMessages="props.errorMessages.roleType"
    />
  </div>
</template>
